// src/components/common/CardSection/CardSection.jsx
import React from "react";
import "./CardSection.css";

export default function CardSection({ children }) {
  return <div className="card-section">{children}</div>;
}
